import React from 'react';
import {Col, Row, Spin} from 'antd';

import AccountBusinessDetails from '../../../components/account/AccountBusinessDetails';
import PageTitle from '../../../components/page/PageTitle';
import {messageType, showMessages} from '../../../helpers/message';
import {useGetCompanyQuery} from '../../../store/api/companyApi';
import {BaseError} from '../../../types/apiTypes';

import {cardsGridColumn} from '../../../assets/styles';
import {useAppSelector} from '../../../hooks/useStore';
import {selectCurrentProfile} from '../../../store/slices/userSlice';
import AddressCard from '../../../components/contactMethod/AddressCard';

import '../../../containers/staff/accounts/AccountBusinessInfo.less';

const AccountBusinessInfo = () => {
    const activeAccount = useAppSelector(selectCurrentProfile)?.account;

    const { data: company, isLoading: isCompanyLoading, error: companyError} = useGetCompanyQuery(activeAccount?.company_id);

    React.useEffect(() => {
        if (companyError) {
            const errorMessage = (companyError as BaseError)?.data?.message || (companyError as BaseError)?.error?.data?.message;
            showMessages(errorMessage, messageType.error);
        }
    }, [companyError]);

    return (
        <>
            <PageTitle title="Company Info"/>
            <Spin spinning={isCompanyLoading}>
                <Row gutter={{sm: 16}}>
                    <Col {...cardsGridColumn}>
                        <AccountBusinessDetails companyData={company || {}}/>
                    </Col>
                    <Col {...cardsGridColumn}>
                        <AddressCard contactableType="company"/>
                    </Col>
                </Row>
            </Spin>
        </>
    );
};

export default AccountBusinessInfo;
